import React from 'react';
import './Cali.css'; 

const Bucaramanga = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
    <h1><a className='Titulo' href="/aip/SKBG.pdf" target="_blank" rel="noreferrer">Aeropuerto Palonegro</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 17</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA1E.pdf" target="_blank" rel="noreferrer">EJA1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA1E.pdf" target="_blank" rel="noreferrer">UBMU1B</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/ESNU1G.pdf" target="_blank" rel="noreferrer">ESNU1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/ESNU1G.pdf" target="_blank" rel="noreferrer">MOGO1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/ESNU1G.pdf" target="_blank" rel="noreferrer">VOVG1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA1G.pdf" target="_blank" rel="noreferrer">EJA1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA1G.pdf" target="_blank" rel="noreferrer">MOGO1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA1G.pdf" target="_blank" rel="noreferrer">UMKA1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA1G.pdf" target="_blank" rel="noreferrer">VOVG1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/ESNU2J.pdf" target="_blank" rel="noreferrer">ESNU2J</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/ESNU2J.pdf" target="_blank" rel="noreferrer">UBMU2D</a></th>
          </tr>


          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 35</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA2D.pdf" target="_blank" rel="noreferrer">EJA2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA2D.pdf" target="_blank" rel="noreferrer">UBMU1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/ESNU1F.pdf" target="_blank" rel="noreferrer">ESNU1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/ESNU1F.pdf" target="_blank" rel="noreferrer">MOGO1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/ESNU1F.pdf" target="_blank" rel="noreferrer">VOVG1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA2F.pdf" target="_blank" rel="noreferrer">EJA2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA2F.pdf" target="_blank" rel="noreferrer">UBMU1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/ESNU2H.pdf" target="_blank" rel="noreferrer">ESNU2H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/MOGO1B.pdf" target="_blank" rel="noreferrer">MOGO1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/MOGO1B.pdf" target="_blank" rel="noreferrer">UMKA1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/MOGO1B.pdf" target="_blank" rel="noreferrer">VOVG1C</a></th>
          </tr>



          
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 17</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/MOGO2A.pdf" target="_blank" rel="noreferrer">MOGO2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/MOGO2A.pdf" target="_blank" rel="noreferrer">OPRO1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA1H.pdf" target="_blank" rel="noreferrer">EJA1H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA1H.pdf" target="_blank" rel="noreferrer">IVRI1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA1H.pdf" target="_blank" rel="noreferrer">POXO1H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA1H.pdf" target="_blank" rel="noreferrer">TORA1Q</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA1H.pdf" target="_blank" rel="noreferrer">VOVG1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA2C.pdf" target="_blank" rel="noreferrer">EJA2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA2C.pdf" target="_blank" rel="noreferrer">MOGO2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA2C.pdf" target="_blank" rel="noreferrer">OPRO1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA2C.pdf" target="_blank" rel="noreferrer">POXO1J</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA2C.pdf" target="_blank" rel="noreferrer">VOVG1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/IVRI1C.pdf" target="_blank" rel="noreferrer">IVRI1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/IVRI1C.pdf" target="_blank" rel="noreferrer">TORA1S</a></th>
          </tr>


          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 35</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/MOGO2A.pdf" target="_blank" rel="noreferrer">MOGO2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/MOGO2A.pdf" target="_blank" rel="noreferrer">OPRO1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA1H.pdf" target="_blank" rel="noreferrer">EJA1H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA1H.pdf" target="_blank" rel="noreferrer">IVRI1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA1H.pdf" target="_blank" rel="noreferrer">POXO1H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA1H.pdf" target="_blank" rel="noreferrer">TORA1Q</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/EJA1H.pdf" target="_blank" rel="noreferrer">VOVG1E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/MOGO2C.pdf" target="_blank" rel="noreferrer">MOGO2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/MOGO2C.pdf" target="_blank" rel="noreferrer">OPRO1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/MOGO2C.pdf" target="_blank" rel="noreferrer">VOVG1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/IVRI1B.pdf" target="_blank" rel="noreferrer">IVRI1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/IVRI1B.pdf" target="_blank" rel="noreferrer">POXO2F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/IVRI1B.pdf" target="_blank" rel="noreferrer">TORA1R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/IVRI1B.pdf" target="_blank" rel="noreferrer">UMKA2C</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 17</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/VORA17.pdf" target="_blank" rel="noreferrer">VOR A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/RNP17.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 35</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/ILSZ35.pdf" target="_blank" rel="noreferrer">ILS Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/ILSY35.pdf" target="_blank" rel="noreferrer">ILS Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/ILSZ35.pdf" target="_blank" rel="noreferrer">LOC Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/ILSY35.pdf" target="_blank" rel="noreferrer">LOC Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/VOR35.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBG/RNP35.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Bucaramanga;